<template>
	<div class='placeholder'>
		<div class="placeholder-image">
		</div>

		<div class="placeholder-lines">
			<div v-for="i in lines" :style="'height: ' + lineSize + 'px'" :key="i"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		lines: {
			type: Number,
			default: 3
		},

		lineSize: {
			type: Number,
			default: 20
		}
	}
}
</script>

<style scoped>
.placeholder {
	width: 100%;
}
.placeholder-image {
	position: relative;
	width: 100%;
	height: 1px;
	padding-bottom: 50%;
	overflow: hidden;
	background: #ededed;
}

.placeholder-lines {
	width: 100%;
}

.placeholder-lines div {
	margin: 10px 0;
	background: #ededed;
}

.placeholder-lines div:nth-child(3n-2) {
	width: 100%;
}

.placeholder-lines div:nth-child(3n-1) {
	width: 40%;
}

.placeholder-lines div:nth-child(3n) {
	width: 70%;
}

@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}

.animated {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    height: auto;
    position: relative;
}
</style>
